module.exports = __webpack_public_path__ + "static/avatar-65b79a1e622e582492d6d214990fa827.jpg";